<template>
    <div class="container q-my-md title">
        <h2 class="q-mt-none q-mb-md" v-html="title" style="color: #2c2266 !important;"></h2>
        <p v-if="subtitle" class="q-ma-none" v-html="subtitle"></p>
        <div v-if="back" class="back">
            <q-btn flat round size="sm" color="primary" icon="arrow left"
                   @click="$router.go(-1)"></q-btn>
        </div>
    </div>
</template>

<script>
    import {
        QBtn,
    } from 'quasar-framework'

    export default {
        name: 'VTitle',

        props: {
            title: {
                type: String,
                required: true,
            },
            subtitle: String,
            back: {
                type: Boolean,
                default: true,
            },
        },

        components: {
            QBtn,
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/front/Title.vue